import Web3 from "web3";

const SIGNING_DOMAIN_NAME = "ARTETRA-Voucher"
const SIGNING_DOMAIN_VERSION = "1"
const types = {
    EIP712Domain: [
        {name: "name", type: "string"},
        {name: "version", type: "string"},
        {name: "chainId", type: "uint256"},
        {name: "verifyingContract", type: "address"},
      ],
      ARTETRAVoucher: [
        {name: "tokenId", type: "uint256"},
        {name: "price", type: "uint256"},
        {name: "royaltyRate", type: "uint256"},
        {name: "uri", type: "string"},
        {name: "resell", type: "bool"}
      ]
}

const _signingDomain = (chainId: number) => {
    return {
        name: SIGNING_DOMAIN_NAME,
        version: SIGNING_DOMAIN_VERSION,
        verifyingContract: process.env.REACT_APP_MARKETPLACE_CONTRACT,
        chainId,
    }
}

const _formatVoucher = (voucher: any, chainId: number) => {
    const domain = _signingDomain(chainId);
    return {
        domain,
        types,
        primaryType: 'ARTETRAVoucher',
        message: voucher,
    }
}

export const getSignature = async (web3: Web3, address: string, voucher: any) => {
    const chainId = await web3.eth.getChainId();
    const _chain_id = process.env.REACT_APP_CHAIN_ID as any;
    if(_chain_id != chainId) {
        await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: process.env.REACT_APP_CHAIN_ID }], // chainId must be in hexadecimal numbers
        });
    }

    const typedData = _formatVoucher(voucher, _chain_id);
    const _provider = web3.currentProvider as any;
    const signature = await _provider.request({
        method: 'eth_signTypedData_v4',
        params: [address, JSON.stringify(typedData)]
    });
    return { message: JSON.stringify(typedData), signature }
}

export const ethToWei = (web3: Web3, amount: number) => {
    return BigInt('0x' + (amount * 10 ** 18).toString(16));
}